import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { DataProtectionNoticeCountriesListFacade } from './data-protection-notice-countries-list.facade';

@Injectable({
  providedIn: 'root',
})
export class DataProtectionNoticeCountriesListGuard {
  constructor(private dpnListFacade: DataProtectionNoticeCountriesListFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.dpnListFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.dpnListFacade);
  }
}
